// Handling login APIs

import { getBaseUrl } from "./helper";

jQuery(function ($) {
  $(".user-logout").on("click", function (e) {
    e.preventDefault();
    const baseUrl = getBaseUrl();

    $('body').append('<div class="loading-blocker" style="z-index: 99999;"></div>');

    $.get(baseUrl + 'session/token', function(token) {
      $.ajax({
        url: baseUrl + 'api/user/logout',
        method: 'GET',
        headers: {
          'X-CSRF-Token': token
        },
        dataType: 'text',
        success: function(response) {
          // console.log('Logged out via custom API', response);
          window.location = baseUrl;
        },
        error: function(response) {
          console.log('Error: logout failed', response);
          redirectUserLogout();
        }
      });
    });

    return;
  });

  function redirectUserLogout() {
    const baseUrl = getBaseUrl();
    window.location.replace(baseUrl + "user/logout");
  }

  styleDefaultUserForm();

  function styleDefaultUserForm() {
    const userEditForm = $(".gsod-user-edit-page .user-form");

    userEditForm
      .find('.form-item.form-item-mail input[type="email"]')
      .attr("readonly", true);

    userEditForm.find(".form-wrapper.field--name-field-alert-config").remove();
  }
});
